import { faFilePdf } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get, intersection, isEmpty, isNull } from "lodash";
import React from "react";
import { CsplTable as Table, AddToolTip } from "../../../../components";
import payrollFrequency from "./../../../../mocks/payrollFrequency.json";
import {
  CalculateAmortizationSchedule,
  getNullTableItem,
  usCurrency,
  usDateFormat,
} from "../../../../utils";
import { DownloadloanAmortizationSchedule } from "../../../../services";
import FileSaver from "file-saver";
import ModificationDetails from "../RepaymentSchedule/ModificationDetails";
import { Link } from "react-router-dom";

const columns = [
  {
    label: "Installment",
    className: "column-installment",
    columnName: "installmentCount",
  },
  {
    label: "Principal",
    className: "column-principal",
    columnName: "principal",
  },
  {
    label: "Interest ",
    className: "column-interest ",
    columnName: "interest",
  },
  {
    label: "Payment per period",
    className: "column-payment-per-period",
    columnName: "payment",
  },
  {
    label: "Outstanding",
    className: "column-outstanding",
    columnName: "balancePrincipal",
  },
];

const AmortizationSchedule = ({
  loanData,
  hideDownload = false,
  loanRefinancebool = false,
  loanStatus,
  amortizationSchedule = [],
  requestId,
  noOfInstallments = 0,
  requestSummary = false,
}) => {
  let installment = 0;
  const amortizationData =
    [null, "InProgress", "AwaitingApproval"].includes(loanStatus) ||
    loanRefinancebool ||
    requestSummary
      ? CalculateAmortizationSchedule(
          {
            frequency: payrollFrequency.data
              .find((_) => _.value == get(loanData, "repaymentFrequency", null))
              ?.label.replace("-", ""),
            loanRequestAmout:
              get(loanData, "requestedAmount", null) ??
              get(loanData, "loanRequestAmount", null) ??
              get(loanData, "loanAmount", null),
            interest: get(loanData, "interestRate", null),
            tenureYears: get(loanData, "tenureYears", null),
            tenureMonths: get(loanData, "tenureMonths", null),
            periodicPayment:
              loanData?.periodicPayment ?? loanData?.periodicPaymentAmount,
            firstRepaymentDate:
              get(loanData, "firstRepaymentDate", null) ?? new Date(),
          },
          noOfInstallments
        )
      : amortizationSchedule.map((_, index) => {
          return (_ = {
            principal: _.principal,
            interest: _.interest,
            payment: _.amount,
            balancePrincipal: _.totalOutstandingPrincipal,
            reAmortizationRequestDetails: _.reAmortizationRequestDetails,
            loanSuspension: _.loanSuspension,
          });
        });

  return (
    <div className="loan-page-scroll ml-3 mt-2">
      <div className="d-flex justify-content-between align-items-baseline mb-1">
        {loanRefinancebool ? (
          <>
            <div className="ft-16 fw-800">Repayment Schedule</div>
            <div className="ft-15" style={{ color: "#919191" }}>
              {amortizationData.length} installments
            </div>
          </>
        ) : (
          <>
            <div className="ft-14 fw-500">Amortization Schedule</div>
            {!hideDownload && (
              <div className="ft-12">
                <FontAwesomeIcon
                  color={"#C4061A"}
                  className={"ft-16 mr-2"}
                  icon={faFilePdf}
                />
                <Link
                  onClick={() => {
                    const val = { LoanId: 5 };
                    val.LoanId = requestId;
                    DownloadloanAmortizationSchedule(val)
                      .then((response) => {
                        var blob = new Blob([response], {
                          type: "application/pdf",
                        });
                        FileSaver.saveAs(
                          blob,
                          loanData.loanStatus == 8
                            ? "Finalized Amortization Schedule -" +
                                loanData.loanIdentifier +
                                ""
                            : "Tentative Amortization Schedule -" +
                                loanData.loanIdentifier +
                                "" //Active ==8
                        );
                      })
                      .catch((error) => {});
                  }}
                  className="loan-anchor-color cursor-pointer"
                >
                  Download
                </Link>
              </div>
            )}
          </>
        )}
      </div>
      <div className="loan-table">
        <Table>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {!isEmpty(amortizationData) ? (
              amortizationData.map((data, index) => {
                return (isNull(data?.reAmortizationRequestDetails) &&
                  isNull(data?.loanSuspension)) ||
                  loanRefinancebool ||
                  requestSummary ||
                  ["InProgress", "AwaitingApproval", null].includes(
                    loanStatus
                  ) ? (
                  <Table.Tr key={index}>
                    {columns.map((item, cellIndex) => {
                      const getContent = () => {
                        if (item.columnName == "installmentCount") {
                          return data.reAmortizationRequestDetails == null &&
                            data.loanSuspension == null
                            ? ++installment
                            : null;
                        }
                        if (
                          [
                            "payment",
                            "principal",
                            "balancePrincipal",
                            "interest",
                          ].includes(item.columnName)
                        ) {
                          return <>{usCurrency(data[item.columnName])}</>;
                        }
                        return data[item.columnName];
                      };

                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {getNullTableItem(getContent())}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                ) : (
                  <Table.Tr key={index}>
                    <ModificationDetails
                      loanActivationDate={loanData.loanActivationDate}
                      data={data}
                    />
                  </Table.Tr>
                );
              })
            ) : (
              <div class="d-flex align-items-center justify-content-center">
                No Records Found
              </div>
            )}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  );
};

export default AmortizationSchedule;
